import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20a%20large%20monitor%20displaying%20colorful%20data%20charts%20on%20a%20clean%20white%20desk%2C%20natural%20daylight%20flooding%20through%20large%20windows%2C%20minimalist%20office%20with%20a%20small%20monstera%20plant%20and%20coffee%20cup%2C%20warm%20white%20walls%2C%20organized%20and%20productive%20atmosphere%2C%20no%20visible%20screen%20text%2C%20Scandinavian%20modern%20aesthetic%2C%20bright%20and%20airy%20mood&width=800&height=600&seq=about-v2-workspace&orientation=landscape"
                alt="AllChinaBuy Spreadsheet workspace"
                title="AllChinaBuy Spreadsheet – China Sourcing Workspace"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
              What Is AllChinaBuy Spreadsheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
              Your Centralized China Sourcing Intelligence System
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-6">
              AllChinaBuy Spreadsheet is a structured sourcing intelligence system designed to help dropshippers, resellers, and e-commerce entrepreneurs navigate the complex world of China sourcing. Unlike traditional agent websites that scatter information across multiple pages, our spreadsheet system organizes verified supplier data, pricing comparisons, and agent reviews into a searchable, filterable format that saves you hours of research.
            </p>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              Whether you are sourcing shoes, apparel, accessories, or electronics from China, the AllChinaBuy Spreadsheet provides the transparency and organization you need to make informed buying decisions without the guesswork.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/allchinabuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300/60 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                Open Spreadsheet
                <i className="ri-external-link-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}